import api from './api'

const resource = '/employees'

export default {
    get(page, region, branch, outlet, q, position) {
        return api.get(`${resource}?page=${page}&region_code=${region}&branch_code=${branch}&outlet_code=${outlet}&q=${q}&position=${position}`);
    },
    getOne(npp) {
        return api.get(`${resource}/${npp}`);
    },
    setAttend(npp){
        return api.post(`${resource}/${npp}`);
    }
}